import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from 'react-redux';
import { setActiveLink } from '../../slices/mainSlice';
import CoachDashboard from "./CoachDashboard";
import Tournaments from "../Tournaments/Tournaments";
import SponsorDashboard from "./SponsorDashboard";

const Dashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { language } = useSelector((state) => state.language);
  const [activeTab, setActiveTab] = useState("tab1");
  const {userDetails,token,userType} = useSelector((state) => state.user);

  console.log("userTypeuserTypeuserTypeuserType",userType)

  useEffect(() => {
    // dispatch(setActiveLink("dashboard"))
  }, [])

return (
  <>
    {userType === "coach" ? (
      <CoachDashboard />
    ) : userType === "sponser" ? (
      <SponsorDashboard />
    ) : (
      <Tournaments />
    )}
  </>
);

};

export default Dashboard;
